import { render, staticRenderFns } from "./ConfigDevNumCmdBox.vue?vue&type=template&id=4b6a6242&scoped=true&"
import script from "./ConfigDevNumCmdBox.vue?vue&type=script&lang=js&"
export * from "./ConfigDevNumCmdBox.vue?vue&type=script&lang=js&"
import style0 from "./ConfigDevNumCmdBox.vue?vue&type=style&index=0&id=4b6a6242&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6a6242",
  null
  
)

export default component.exports